// 获取当前用户的账号版本信息
// http://api.umucdn.cn/project/216/interface/api/3036

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export const getAccountPlan = (): Promise<IResponse<IPlanInfo>> => {
    return fetchData(Api.GET_ACCOUNT_PLAN).then((res: IResponse<IPlanInfo>) => {
        return res;
    });
};
